var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"app"}},[_c(_setup.CanaryMarker),_c(_setup.NoSSR,[_c(_setup.LoginFlow)],1),(!_setup.hideAppHeader)?_c(_setup.AppHeader):_vm._e(),_c('KeepAlive',[_c('RouterView')],1),_c(_setup.StyleInjector),_c(_setup.LowPriorityComponents)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }